import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { useConfig } from 'config/ConfigContext';
import { NEW_NEXT, newNextAction, RANDOM_NEXT, randomNextAction } from 'actions/navigation';
import PlaidComponent from 'components/Plaid';
import Transition from 'components/Transition';
import Progress from 'components/Progress';
import Header from 'components/Header';

import './style.scss';

const Plaid = ({ navigate, searchParams }) => {
  const config = useConfig();
  const dispatch = useDispatch();
  const fetch = useSelector((state) => state.fetch);
  const checkinData = useSelector((state) => state.screen.checkinData);
  const key = searchParams.get('key');
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(null);

  useEffect(() => {
    const sourceData = get(checkinData, 'data', null) || get(checkinData, 'state.data', null);
    if (!sourceData) {
      navigate(`/plaid/welcome/?key=${key}`);
    }
  }, []);

  useEffect(() => {
    if (fetch.isDone[`${RANDOM_NEXT}`] && !fetch.isRunning[`${RANDOM_NEXT}`]) {
      if (get(checkinData, 'data.data.nextAction.path') || get(checkinData, 'state.data.nextAction.path')) {
        dispatch(randomNextAction({
          rawUrl: get(checkinData, 'data.data.nextAction.path') || get(checkinData, 'state.data.nextAction.path'),
          data: {},
        }));
      } else if (get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path')) {
        dispatch(randomNextAction({
          rawUrl: get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path'),
          data: {},
        }));
      } else if (get(checkinData, 'data.url') || get(checkinData, 'state.url')) {
        const url = get(checkinData, 'data.url') || get(checkinData, 'state.url');
        const routeUrl = url.replace(config.hostUrl, '');
        navigate(routeUrl);
      }
    } else if (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) {
      if (get(checkinData, 'data.data.nextAction.path') || get(checkinData, 'state.data.nextAction.path')) {
        dispatch(randomNextAction({
          rawUrl: get(checkinData, 'data.data.nextAction.path') || get(checkinData, 'state.data.nextAction.path'),
          data: {},
        }));
      } else if (get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path')) {
        dispatch(randomNextAction({
          rawUrl: get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path'),
          data: {},
        }));
      } else if (get(checkinData, 'data.url') || get(checkinData, 'state.url')) {
        const url = get(checkinData, 'data.url') || get(checkinData, 'state.url');
        const routeUrl = url.replace(config.hostUrl, '');
        navigate(routeUrl);
      }
    }
  }, [checkinData]);

  const handlePlaidSuccess = (publicToken, metaData) => {
    const accountsData = get(metaData, 'accounts', []).map((accountData) => ({
      accountId: get(accountData, 'id'),
      mask: get(accountData, 'mask'),
      name: get(accountData, 'name'),
      subtype: get(accountData, 'subtype'),
      type: get(accountData, 'type'),
    }));
    const requestData = {
      plaidSessionId: get(checkinData, 'data.sessionId'),
      linkSessionId: get(metaData, 'link_session_id'),
      publicToken,
      accounts: accountsData,
      institution: {
        institutionId: get(metaData, 'institution.institution_id'),
        name: get(metaData, 'institution.name'),
      },
    };

    dispatch(newNextAction({
      key,
      workflowType: 'plaid',
      data: requestData,
      onUploadProgress: (progressEvent) => {
        setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
      },
      fail: (err) => {
        console.log(err);
        setIsProgressVisible(false);
      },
    }));
  };

  const handlePlaidExit = () => {
    navigate(`/plaid/welcome/?key=${key}`);
  };

  return (
    <Transition className="transition-item wrapper vh-100">
      <Header />
      <div className="content">
        {get(checkinData, 'data.sessionId') && <PlaidComponent onPlaidSuccess={handlePlaidSuccess} onPlaidExit={handlePlaidExit} sessionId={get(checkinData, 'data.sessionId')} linkToken={get(checkinData, 'data.linkToken')} />}
      </div>
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </Transition>
  );
};

Plaid.propTypes = {
  navigate: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default Plaid;
